import React, { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import { useHistory, useLocation, useParams } from "react-router-dom";
import {
  Box,
  List,
  ListItem,
  ListItemButton,
  Typography,
  Drawer,
  IconButton,
  Link,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";

const Groups = () => {
  const { playingMode } = useParams();
  const location = useLocation(); // To get the current pathname
  const history = useHistory();
  const groups = useSelector((state) => state.groupsList);
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    setVisible(location.pathname.includes("categories"));
  }, [location.pathname]);

  const handleClose = () => {
    setVisible(false);
    history.goBack();
  };

  const handleCategoryClick = (id) => {
    setVisible(false);
    if (id === -1 && playingMode !== "live") {
      history.replace(`/${playingMode}/`);
    } else {
      console.log(id);
      history.replace(
        `/${playingMode}/category/${id}/`
      );
    }
  };

  // Only render Drawer if navbar is true and groups is available
  return (
    visible &&
    groups.length > 0 && (
      <Drawer
        anchor="left"
        open={visible}
        onClose={handleClose}
        sx={{ zIndex: 10 }}
      >
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            p: 2,
          }}
        >
          <IconButton onClick={handleClose} aria-label="close">
            <CloseIcon />
          </IconButton>
        </Box>
        <List
          sx={{
            maxHeight: "100vh",
            overflow: "auto", // Enable scrolling for the list
          }}
        >
          {playingMode !== "live" && (
            <ListItem key="GP-1" disablePadding>
              <ListItemButton onClick={() => handleCategoryClick(-1)}>
                <Typography>All</Typography>
              </ListItemButton>
            </ListItem>
          )}
          {groups &&
            groups.map((gp) => (
              <ListItem key={"GP" + gp.category_id} disablePadding>
                <ListItemButton onClick={() => handleCategoryClick(gp.category_id)}>
                  <Typography>{gp.category_name}</Typography>
                </ListItemButton>
              </ListItem>
            ))}
        </List>
      </Drawer>
    )
  );
};

export default Groups;
